import { defaultLocale, isSupportedLocale, type Locale } from '@/config/i18n/locales';
import { extractIdFromUrl } from '@/common/helpers/extractIdFromUrl';

export type ParsedProjectDetailPath = {
  locale: Locale;
  projectId: string;
};

export const parseProjectDetailPath = (pathname: string): ParsedProjectDetailPath | null => {
  const segments = pathname.split('/').filter(Boolean);
  if (segments.length < 2) return null;

  let locale: Locale = defaultLocale;
  let projectIndex = 0;

  if (isSupportedLocale(segments[0])) {
    locale = segments[0];
    projectIndex = 1;
  }

  if (segments[projectIndex] !== 'project') return null;

  const slug = segments[projectIndex + 1];
  if (!slug) return null;

  const projectId = extractIdFromUrl(slug);
  if (!projectId) return null;

  return { locale, projectId };
};
